import fetch from './fetch';
import { camelizeKeys, decamelizeKeys } from 'humps'

const logResponse = (response) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(response);
  }
}

const decodeResponse = async (response) => {
  const text = await response.text();
  try {
    const json = JSON.parse(text);
    return typeof(json) === 'object' ? camelizeKeys(json) : json;
  } catch (error) {
    return text;
  }
}

const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    return decodeResponse(response).then(parsedText => {
      error.body = parsedText;
      logResponse(parsedText);
      throw error;
    })
  }
};

export default class Api {
  constructor() {
    this.baseUrl = `${process.env.AMAZY_BASE_URL}/api`;
  };

  fetchCompanyInfo = () => {
    return this.request('GET', '/organisation');
  };

  fetchOrganisations = () => {
    return this.request('GET', '/organisations');
  };

  fetchOrganisation = (id) => {
    return this.request('GET', `/organisations/${id}`);
  };

  createOrganisation = (attrs) => {
    return this.request('POST', `/organisations`, decamelizeKeys({ organisation: attrs }));
  };

  updateOrganisation = (attrs) => {
    return this.request('PUT', `/organisations/${attrs.id}`, decamelizeKeys({ organisation: attrs }));
  };

  fetchTransactions = () => {
    return this.request('GET', '/transactions');
  };

  fetchInvoices = () => {
    return this.request('GET', '/invoices');
  };

  fetchQuotes = (orgId) => {
    return this.request('GET', `/organisations/${orgId}/quotes`)
  };

  calculateQuote = (params) => {
    return this.request('POST', '/quote', decamelizeKeys(params));
  };

  bindQuote = (orgId, quoteUuid, applicationNumber=null) => {
    const params = { organisationId: orgId, quoteUuid, applicationNumber };
    return this.request('POST', '/quote/bind', decamelizeKeys(params));
  }

  fetchLoansByOrg = (orgId) => {
    return this.request('GET', `/organisations/${orgId}/loans`)
  };

  fetchLoans = (params) => {
    return this.request('GET', `/loans?${this.json2params(decamelizeKeys(params))}`)
  }

  updateLoan = (loanId, payload) => (this.request('PATCH', `/loans/${loanId}`, decamelizeKeys(payload)))

  fetchLoanReminders = () => {
    return this.request('GET', '/loan_schedule/reminder')
  }

  fetchApplications = (params) => {
    if (params) {
      return this.request('GET', `/applications?${this.json2params(decamelizeKeys(params))}`);
    }
    return this.request('GET', '/applications');
  };

  fetchApplication = (appNumber, params) => {
    if (params) {
      return this.request('GET', `/applications/${appNumber}?${this.json2params(decamelizeKeys(params))}`);
    }
    return this.request('GET', `/applications/${appNumber}`);
  };

  createApplication = (params) => {
    return this.request('POST', '/applications', decamelizeKeys(params));
  };

  updateApplication = (appNumber, form) => {
    const params = { form };

    return this.request('PATCH', `/applications/${appNumber}`, decamelizeKeys(params));
  };

  requestDoc = (appNumber, request_doc) => {
    return this.request('PUT', `/applications/${appNumber}/request_doc`, decamelizeKeys({request_doc}));
  };

  approveApplication = (appNumber) => {
    return this.request('PUT', `/applications/${appNumber}/approve`);
  };

  rejectApplication = (appNumber) => {
    return this.request('PUT', `/applications/${appNumber}/reject`);
  };

  confirmRepayment = (loanScheduleId, status) => {
    return this.request('POST', `/repayments`, decamelizeKeys({loanScheduleId, status}));
  };

  noteLoanSchedule = (loanScheduleId, note) => {
    return this.request('POST', `/repayments/note`, decamelizeKeys({loanScheduleId, note}));
  };

  notifyCustomer = (loanScheduleId) => {
    return this.request('POST', `/repayments/notify_customer`, decamelizeKeys({loanScheduleId}));
  }

  fetchXeroSnapshotByOrgId = (orgId) => {
    return this.request('GET', `/organisations/${orgId}/xero_snapshot`);
  }

  customOauth = ({provider, email, uid, name}) => {
    const overrideUrl = `${process.env.AMAZY_BASE_URL}/custom_oauth`;
    return this.request('POST', '/custom_oauth', decamelizeKeys({ provider, email, uid, name }), overrideUrl);
  }

  request = (method, suffixUrl, data, overrideUrl=null) => {
    return fetch(
      overrideUrl || `${this.baseUrl}${suffixUrl}`,
      {
        method,
        body: JSON.stringify(data),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      },
    )
      .then(checkStatus)
      .then(decodeResponse);
  };

  json2params = (json) => (Object.entries(json).map(e => e.join('=')).join('&'));
}



// WEBPACK FOOTER //
// ./src/utils/api.js